import { reactive } from 'vue'
import { defineStore } from 'pinia'
import Introduction from '@/components/views/Introduction.vue'
import Whatsapp from '@/components/views/Whatsapp.vue'
import Address from '@/components/views/Address.vue'
import CarInfo from '@/components/views/CarInfo.vue'
import ScheduleAppointment from '@/components/views/ScheduleAppointment.vue'
import Payment from '@/components/views/Payment.vue'
import PaymentResult from '@/components/views/PaymentResult.vue'
import ScheduleAppointmentResult from '@/components/views/ScheduleAppointmentResult.vue'
import RescheduleAppointment from '@/components/views/RescheduleAppointment.vue'
import TimesUp from '@/components/views/TimesUp.vue'
import RevolutPayment from '@/components/views/RevolutPayment.vue'
import StripePayment from '@/components/views/StripePayment.vue'

export const useRouterStore = defineStore('router', () => {
  const views = [
    {
      name: 'home',
      component: Introduction
    },
    {
      name: 'whatsapp',
      component: Whatsapp
    },
    {
      name: 'carinfo',
      component: CarInfo,
      query: 'accepted'
    },
    {
      name: 'address',
      component: Address
    },
    {
      name: 'payment',
      component: Payment
    },
    {
      name: 'payment-revolut',
      component: RevolutPayment
    },
    {
      name: 'payment-stripe',
      component: StripePayment
    },
    {
      name: 'payment-success',
      component: PaymentResult,
      query: 'redirect_status'
    },
    {
      name: 'timesup',
      component: TimesUp
    },
    {
      name: 'schedule-appointment',
      component: ScheduleAppointment,
      query: 'delivered'
    },
    {
      name: 'schedule-appointment-result',
      component: ScheduleAppointmentResult
    },
    {
      name: 'reschedule-appointment',
      component: RescheduleAppointment,
      query: 'reschedule'
    }
  ]

  type StareType = {
    name: string
    component:
      | typeof Whatsapp
      | typeof Introduction
      | typeof Address
      | typeof CarInfo
      | typeof ScheduleAppointment
      | typeof Payment
      | typeof PaymentResult
      | typeof ScheduleAppointmentResult
      | typeof TimesUp
      | typeof RevolutPayment
      | typeof StripePayment
      | typeof RescheduleAppointment
      | any
    params: any
    lastView: string[]
  }

  const current = reactive<StareType>({
    name: 'home',
    component: Introduction,
    params: {},
    lastView: []
  })

  const push = (name: string, fromBack?: boolean) => {
    const to = views.find((el) => el.name === name)

    if (to) {
      if (!fromBack) {
        current.lastView.push(current.name)
      }
      current.name = to.name
      current.component = to.component
    }
  }

  const back = () => {
    if (current.lastView.length) {
      const last = current.lastView.pop()

      if (last) {
        push(last, true)
      }
    }
  }

  const validateParams = (params: string) => {
    const queryParams = params.split('&').reduce((result, param) => {
      const [key, value] = param.split('=')
      result[key] = value
      return result
    }, {})

    for (const param in queryParams) {
      const view = views.find((view) => view.query === param)

      if (view) {
        current.name = view.name
        current.component = view.component
        current.params = queryParams
        break
      }
    }
  }

  const resetParams = () => {
    current.params = {}
  }

  return {
    current,
    push,
    back,
    validateParams,
    resetParams
  }
})
